export const ReviewStatus = {
    TREATED: "TREATED",
    WAITING: "WAITING",
}
